import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SystemAlertsBell',
  props: {
    groups: null,
    trialDaysRemaining: null
  },
  setup(__props: any) {

const props = __props as {
  groups: any[]
  trialDaysRemaining: number
}



const inst = getCurrentInstance()

const isOpen = ref(false)
const isLightMode = ref(false)
const rootEl = ref<HTMLElement | null>(null)

const alerts = computed(() => {
  const items: any[] = []

  for (const g of props.groups || []) {
    if (Number(g.email_dns_alert) === 1) {
      items.push({
        key: 'email-dns-' + g.id,
        title: 'Email domain failed verification',
        text: g.name + ': ' + g.email_domain + ' DNS records are failing. Automated emails fall back to the default sender and campaigns are paused until the records are restored. Click to review.',
        critical: true,
        route: '/mail/settings'
      })
    }

    if (Number(g.suppressed_staff_count) > 0) {
      const n = Number(g.suppressed_staff_count)
      const who = n === 1 ? '1 staff member' : n + ' staff members'
      items.push({
        key: 'email-suppressed-' + g.id,
        title: 'Staff email delivery blocked',
        text: g.name + ': notification emails to ' + who + ' are blocked because their email provider reported a past message as spam. They can restore delivery from their own profile page. Click to review your staff list.',
        critical: false,
        route: '/settings/user-management'
      })
    }
  }

  if (props.trialDaysRemaining === 0) {
    items.push({
      key: 'trial',
      title: 'Your trial ends today',
      text: '',
      critical: false,
      route: null
    })
  } else if (props.trialDaysRemaining > 0) {
    const days = props.trialDaysRemaining === 1 ? '1 day' : props.trialDaysRemaining + ' days'
    items.push({
      key: 'trial',
      title: 'Your trial ends in ' + days,
      text: '',
      critical: false,
      route: null
    })
  }

  return items
})

const themeClass = computed(() => (isLightMode.value ? 'theme-light' : 'theme-dark'))

function toggle() {
  isLightMode.value = document.body.classList.contains('white-content')
  isOpen.value = !isOpen.value
}

function close() {
  isOpen.value = false
}

function onAlertClick(alert: any) {
  if (!alert.route) return
  close()
  const router = inst?.proxy?.$router
  if (router && router.currentRoute.path !== alert.route) {
    router.push(alert.route)
  }
}

function onDocumentClick(event: MouseEvent) {
  const el = rootEl.value
  if (el && !(el === event.target || el.contains(event.target as Node))) {
    close()
  }
}

onMounted(() => {
  document.addEventListener('click', onDocumentClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onDocumentClick)
})

return { __sfc: true,props, inst, isOpen, isLightMode, rootEl, alerts, themeClass, toggle, close, onAlertClick, onDocumentClick }
}

})